<div class="flex flex-col max-w-240 md:min-w-160 -m-6 rounded-lg">
    <!-- Header -->
    <div class="flex flex-0 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg">Información Ciudadano</div>
        <button
            mat-icon-button
            (click)="dialogRef.close()"
            [tabIndex]="-1">
            <mat-icon
                class="text-current"
                [svgIcon]="'heroicons_outline:x'"></mat-icon>
        </button>
    </div>
    <div class="flex flex-col flex-auto p-4 sm:p-4 overflow-y-auto contenedor-formulario">
        <mat-form-field appearance="outline" class = "flex-initial w-full">
            <mat-label>Nombre</mat-label>
            <input disabled placeholder="Nombre" matInput [(ngModel)]="nombre">
        </mat-form-field>
        <mat-form-field appearance="outline" class = "flex-initial w-full">
            <mat-label>CURP</mat-label>
            <input disabled placeholder="CURP" matInput [(ngModel)]="curp">
        </mat-form-field>
        <mat-form-field appearance="outline" class = "flex-initial w-full">
            <mat-label>RFC</mat-label>
            <input disabled placeholder="RFC" matInput [(ngModel)]="rfc">
        </mat-form-field>
        <mat-form-field appearance="outline" class = "flex-initial w-full">
            <mat-label>Correo electrónico</mat-label>
            <input disabled placeholder="Correo electrónico" matInput [(ngModel)]="email">
        </mat-form-field>

    </div>
    <div class="flex flex-row p-6 sm:p-8 justify-end items-end content-end">
        <button class="mr-8" mat-raised-button type="button" (click)="dialogRef.close()">
            Cancelar
        </button>
        <button (click)="save()" mat-raised-button type="button" color="accent">
            Continuar
        </button>
    </div>
</div>

